export const SHELL_TIME_ZONE_COOKIE = "lattice_shell_time_zone";

const SHELL_TIME_ZONE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;
const MAX_TIME_ZONE_LENGTH = 100;

export function parseShellTimeZone(value: string | undefined): string | null {
  if (!value || value.length > MAX_TIME_ZONE_LENGTH * 3) return null;
  try {
    const timeZone = decodeURIComponent(value);
    if (timeZone.length === 0 || timeZone.length > MAX_TIME_ZONE_LENGTH) {
      return null;
    }
    new Intl.DateTimeFormat("en-US", { timeZone }).format();
    return timeZone;
  } catch {
    return null;
  }
}

export function resolveShellGreetingHour(args: {
  now: Date;
  timeZone: string | null;
}): number | null {
  if (args.timeZone === null) return null;
  const hourPart = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hourCycle: "h23",
    timeZone: args.timeZone,
  })
    .formatToParts(args.now)
    .find((part) => part.type === "hour");
  if (!hourPart) return null;
  const hour = Number(hourPart.value);
  return Number.isInteger(hour) && hour >= 0 && hour <= 23 ? hour : null;
}

export function serializeShellTimeZone(timeZone: string): string {
  return [
    `${SHELL_TIME_ZONE_COOKIE}=${encodeURIComponent(timeZone)}`,
    "Path=/app/shell",
    `Max-Age=${SHELL_TIME_ZONE_COOKIE_MAX_AGE_SECONDS}`,
    "SameSite=Lax",
  ].join("; ");
}

export function persistBrowserShellTimeZone(): void {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!timeZone) return;
  document.cookie = serializeShellTimeZone(timeZone);
}
